import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

import { mapListEnvelope, mapOrderListItem } from '@services/api/stock/_transform';

function getUrl() {
  return 'v4/stock-trading/public/order/REG/list';
}

/**
 *
 * @param {string} url
 * @returns
 */
function callbackFetch(url, size) {
  return async ({ pageParam = 1 }) => {
    try {
      /**
       * @type {import('./typedefs').OrderListFilterResponse}
       */
      const res = await fetcher.get(url, {
        params: {
          page: pageParam,
          page_size: size,
        },
      });

      return mapListEnvelope(res.data, mapOrderListItem);
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

export default function fetch({ pageSize = 15 } = {}) {
  const url = getUrl();
  const cb = callbackFetch(url, pageSize);
  const key = [url, pageSize];

  return { cb, key };
}
